import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { useGlobalState } from 'src/context/global'
import { useMediaContext } from 'src/context/responsive'
import styled from 'styled-components'

const Heading = styled.h1`
  display: flex;
  align-items: inherit;
  height: 100%;
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
`

const Img = styled.img`
  height: 2rem;
`

export const Logo = () => {
  const [{ appConfig }] = useGlobalState()
  const { isMobileView } = useMediaContext()

  const sliceDefaultLogo = useMemo(() => {
    if (appConfig.template === 'template-eligibility') {
      return '/logos/centivo.svg'
    }

    return isMobileView ? '/logos/centivo-mobile.svg' : '/logos/centivo.svg'
  }, [isMobileView, appConfig.template])

  return (
    <Heading>
      <Img
        src={isEmpty(appConfig.appLogo) ? sliceDefaultLogo : appConfig.appLogo}
        alt="Centivo logo"
      />
    </Heading>
  )
}
